import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "MeasureMethodologyDashboardPage" */
	'pages/intervention/MeasureMethodology/MeasureMethodologyDashboardPage'));

export default [{ component, exact: true, path: '/measure_methodologies/:measureMethodologyId' }];